module.exports = __webpack_public_path__ + "static/media/logo-ionitron.057a6c2f.svg";